import { render, staticRenderFns } from "./rproduct-details.vue?vue&type=template&id=290a9542"
import script from "./rproduct-details.vue?vue&type=script&lang=ts"
export * from "./rproduct-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports